import { Component, OnInit } from '@angular/core';
import { PageSize } from '../../../core/dto/page.size';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Pagination } from '../../../core/dto/pagination';
import { RentReservationService } from '../../../core/services/rent-reservation.service';
import * as moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from '../../../modules/auth/services/auth.service';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { SETTINGS } from '../../../core/config/common.settings';
import { FleetService } from '../../../core/services/fleet.service';
import { PaymentsService } from '../../../core/services/payments.service';

@Component({
  selector: 'app-rent-reservation',
  templateUrl: './rent-reservation.component.html',
  styleUrls: ['./rent-reservation.component.scss'],
})
export class RentReservationComponent implements OnInit {
  breadcrumbs: any[] = [
    {
      title: 'Rent Bookings',
      icon: 'car',
    },
  ];
  loading = false;
  searchText = '';
  statusFilter: any;
  startDate: any;
  endDate: any;
  dateRanges: any;
  bookingData: any[] = [];
  pageSize = new PageSize();
  sortOrder: any = -1;

  skeletonTableColumns: any[] = [
    'SR Rent ID',
    'Agent Booking Reference',
    'Agent',
    'Country',
    'Pax Count',
    'Status',
    'Customer Name',
    'Local Permit Requirement',
    'No of Days',
    'Arrival Date and Time',
    'Departure Date and Time',
    'Vehicle Type',
    'Allocated Vehicle Reg No',
    'Arrival and Departure Handler',
    'Flight Number',
    'Created Date',
    'Action',
  ];

  //Current Fuel and Mileage Update Stuff
  isVisibleFuelAndMileageUpdate = false;
  changingStatus: any;
  fuelLevel: any = 0;
  mileage: any = 0;
  cancelReason: any = null;
  selectedReservation: any;
  isLoading = false;
  cancelReasonOptions: any[] = [
    'No Show',
    'No International License',
    'No Local License',
    'Vehicle Non Availability',
  ];
  index = 0;
  openPaymentListDatePicker = false;
  paymentDateRanges: any;
  paymentDataLoading = false;
  openMultiplePagingBoardPopup = false;

  // formatterPercentFuel = (value: number): string => `${value} %`;
  // parserPercentFuel = (value: string): string => value.replace(' %', '');
  // formatterDistance = (value: number): string => `${value} KM`;
  // parserDistance = (value: string): string => value.replace(' KM', '');

  constructor(
    private rentReservationService: RentReservationService,
    private fleetService: FleetService,
    private messages: NzMessageService,
    private authService: AuthService,
    private router: Router,
    private paymentService: PaymentsService,
  ) {}

  ngOnInit() {}

  search() {
    this.getPagedRentReservations();
  }

  onChangeDateFilter(result: Date[]): void {
    if (result[0] && result[1]) {
      this.startDate = moment(result[0]).startOf('day').format();
      this.endDate = moment(result[1]).endOf('day').format();
      this.getPagedRentReservations();
    }
  }

  resetSearch(type: string) {
    switch (type) {
      case 'status':
        this.statusFilter = null;
        this.getPagedRentReservations();
        break;
      case 'all':
        this.searchText = '';
        this.statusFilter = null;
        this.startDate = null;
        this.endDate = null;
        this.dateRanges = null;
        this.getPagedRentReservations();
        break;
      case 'date':
        this.startDate = null;
        this.endDate = null;
        this.getPagedRentReservations();
        break;
    }
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedRentReservations();
  }

  getPagedRentReservations(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      // sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        searchText: this.searchText,
        startDate: this.startDate,
        endDate: this.endDate,
        searchStatus: this.statusFilter,
      },
    });
    this.rentReservationService
      .getPagedReservations(payload)
      .subscribe((res: any) => {
        this.loading = false;
        this.bookingData = res[0].data;
        this.pageSize.length = res[0].metadata[0]?.total;
      });
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedRentReservations();
  }

  // getArrivalAndDepartureDateAndTime(date: Date, time: Date): string {
  //   return `${moment(date).format('DD-MM-y')} | ${moment(time).format(
  //     'hh:mm:a',
  //   )}`;
  // }

  getVehicleRegisterNo(data: any): string {
    let vehicleRegisterNumber = '';
    if (
      data?.allocationDetails?.isDriverPromote &&
      data?.allocationDetails?.driverCategory === 'OUTSOURCE_DRIVER'
    ) {
      const allocatedVehicle = data?.allocatedSupplierVehicle;
      vehicleRegisterNumber = allocatedVehicle?.registerNumber;
    } else {
      vehicleRegisterNumber =
        data?.allocationDetails?.allocatedVehicle?.vehicleDetails
          ?.registrationNumber;
    }
    return vehicleRegisterNumber;
  }

  getVehicleCategory(data: any): string {
    if (
      data?.allocationDetails?.isUpgraded ||
      data?.allocationDetails?.isDowngraded
    ) {
      return data?.allocationDetails?.vehicleCategory?.name;
    } else {
      return data?.tourDetails?.vehicleCategory?.name;
    }
  }

  navigateTo(type: string, id: string): void {
    switch (type) {
      case 'edit':
        this.router.navigate([`/admin/booking-rent/add-edit/${id}`]);
        break;
      case 'single':
        this.router.navigate([`/admin/booking-rent/${id}`]);
        break;
    }
  }

  //Current fuel and mileage update stuff
  handleCancelUpdateFuelAndMileage(): void {
    this.isVisibleFuelAndMileageUpdate = false;
    this.fuelLevel = 0;
    this.mileage = 0;
    this.selectedReservation = null;
    this.changingStatus = null;
  }

  handleOkUpdateFuelAndMileage(): void {
    this.isLoading = true;
    const allocationDetails = this.selectedReservation?.allocationDetails;
    allocationDetails.vehicleCategory =
      allocationDetails?.isUpgraded || allocationDetails?.isDowngraded
        ? allocationDetails?.vehicleCategory._id
        : null;
    allocationDetails.allocatedVehicle = allocationDetails?.allocatedVehicle
      ? allocationDetails?.allocatedVehicle._id
      : null;
    allocationDetails.allocatedDriver = allocationDetails?.isDriverPromote
      ? allocationDetails?.allocatedDriver._id
      : null;
    if (this.changingStatus === 'ON_RENT') {
      allocationDetails.startFuel = this.fuelLevel;
      allocationDetails.startMileage = this.mileage;
      this.rentReservationService
        .updateRentReservationFuelAndMileageData({
          allocationDetails,
          _id: this.selectedReservation?._id,
          status: 'ON_RENT',
          updateType: 'status_change',
        })
        .subscribe(
          (res: any) => {
            this.isLoading = false;
            this.messages.create('success', 'Status Changed to On Rent');
            this.updateFleetData('ON_RENT');
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    } else if (this.changingStatus === 'COMPLETED') {
      allocationDetails.endFuel = this.fuelLevel;
      allocationDetails.endMileage = this.mileage;
      this.rentReservationService
        .updateRentReservationFuelAndMileageData({
          allocationDetails,
          _id: this.selectedReservation._id,
          status: 'COMPLETED',
          updateType: 'status_change',
        })
        .subscribe(
          (res: any) => {
            this.isLoading = false;
            this.messages.create('success', 'Status Changed to Completed');
            this.updateFleetData('AVAILABLE');
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    }
  }

  updateFleetData(status: string): void {
    let payload: any = {};
    if (status === 'ON_RENT') {
      payload = {
        _id: this.selectedReservation?.allocationDetails?.allocatedVehicle,
        currentMileage: this.mileage,
        currentFuelLevel: this.fuelLevel,
        currentOnBooking: {
          type: 'RENT',
          id: this.selectedReservation?._id,
        },
        availabilityStatus: status,
      };
    } else {
      payload = {
        _id: this.selectedReservation?.allocationDetails?.allocatedVehicle,
        currentMileage: this.mileage,
        currentFuelLevel: this.fuelLevel,
        currentOnBooking: null,
        availabilityStatus: status,
      };
    }
    this.fleetService.updateFleet(payload).then(() => {
      this.getPagedRentReservations();
      this.isVisibleFuelAndMileageUpdate = false;
      this.changingStatus = null;
      this.selectedReservation = null;
      this.fuelLevel = 0;
      this.mileage = 0;
    });
  }

  handleOkCancelledStatus(): void {
    this.isLoading = true;
    let remarks: any[] = this.selectedReservation?.remarks;
    if (remarks?.length > 0) {
      remarks?.push({
        action: 'Cancelled',
        remark: this.cancelReason,
        createdBy: this.authService.getLoggedInUser().userId,
        createdAt: new Date(),
      });
    } else {
      remarks = [
        {
          action: 'Cancelled',
          remark: this.cancelReason,
          createdBy: this.authService.getLoggedInUser().userId,
          createdAt: new Date(),
        },
      ];
    }
    this.rentReservationService
      .updateRentReservation({
        _id: this.selectedReservation._id,
        status: 'CANCELLED',
        remarks,
        updateType: 'status_change',
      })
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          this.isVisibleFuelAndMileageUpdate = false;
          this.messages.create('success', 'Status Changed to Cancelled');
          this.getPagedRentReservations();
          this.changingStatus = null;
          this.selectedReservation = null;
        },
        (e: any) => {
          this.messages.create('error', 'Error');
        },
      );
  }

  handleOkSelectStatus(status: string, data: any): void {
    this.changingStatus = status;
    this.selectedReservation = data;
    if (status === 'ON_RENT' || status === 'COMPLETED') {
      if (data?.allocationDetails?.driverCategory !== 'OUTSOURCE_DRIVER') {
        this.isVisibleFuelAndMileageUpdate = true;
      } else {
        this.rentReservationService
          .updateRentReservation({
            _id: this.selectedReservation._id,
            status,
            updateType: 'status_change',
          })
          .subscribe(
            (res: any) => {
              this.isLoading = false;
              this.messages.create(
                'success',
                `Status Changed to ${this.convertToNormalString(status)}`,
              );
              this.getPagedRentReservations();
              this.changingStatus = null;
              this.selectedReservation = null;
            },
            (e: any) => {
              this.messages.create('error', 'Error');
            },
          );
      }
    } else if (status === 'CANCELLED') {
      this.isVisibleFuelAndMileageUpdate = true;
    } else if (status === 'RESERVATION') {
      this.rentReservationService
        .updateRentReservation({
          _id: this.selectedReservation._id,
          status: 'RESERVATION',
          updateType: 'status_change',
        })
        .subscribe(
          (res: any) => {
            this.isLoading = false;
            this.messages.create('success', 'Status Changed to Reservation');
            this.getPagedRentReservations();
            this.changingStatus = null;
            this.selectedReservation = null;
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    }
  }

  handleCancelSelectStatus(status?: string, data?: any): void {
    this.changingStatus = null;
    this.isVisibleFuelAndMileageUpdate = false;
    if (status === 'COMPLETED' && data.allocationDetails.allocatedVehicle._id) {
      this.router.navigate(
        [
          `/admin/fleets/${data.allocationDetails.allocatedVehicle._id}/accidents/add-edit`,
        ],
        {
          queryParams: {
            from: 'rent-booking-table',
            booking: data._id,
          },
        },
      );
    }
  }

  convertToNormalString(text: string): string {
    return _.startCase(_.toLower(text));
  }

  addItem(input: HTMLInputElement): void {
    const value = input.value;
    if (this.cancelReasonOptions.indexOf(value) === -1) {
      this.cancelReasonOptions = [
        ...this.cancelReasonOptions,
        input.value || `New item ${this.index++}`,
      ];
    }
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }
  openPaymentCSVDateFilter() {
    this.openPaymentListDatePicker = true;
    this.paymentDataLoading = false;
    this.paymentDateRanges = [];
  }

  onChangePaymentListDatePicker = async (result: Date[]) => {
    if (result[0] && result[1]) {
      this.paymentDataLoading = true;
      const startDate = moment(result[0]).startOf('day').format();
      const endDate = moment(result[1]).endOf('day').format();
      const paymentList = await this.paymentService.getPaymentCSVList({
        startDate,
        endDate,
      });
      this.paymentDataLoading = false;
      if (paymentList.length > 0) {
        this.openPaymentListDatePicker = false;
        this.downloadCSV(paymentList);
      } else {
        this.messages.create('info', 'No payment details on this date range');
      }
    }
  };

  downloadCSV(paymentList: any): void {
    const jsonData = paymentList.map((pay: any) => {
      return {
        Date: pay.createdAt
          ? moment(pay.createdAt).format('DD-MMMM-YYYY')
          : ' - ',
        Description: pay.description ? pay.description : ' - ',
        Amount: pay.totalAmount ? pay.totalAmount : ' - ',
        Customer: pay.customerName ? pay.customerName : ' - ',
      };
    });
    const csvData = this.convertJsonToCSV(jsonData, [
      'Date',
      'Description',
      'Amount',
      'Customer',
    ]);
    this.downloadFile(csvData, 'data.csv', 'text/csv;charset=utf-8;');
  }

  downloadFile(data: string, filename: string, mimeType: string): void {
    const blob = new Blob([data], { type: mimeType });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  convertJsonToCSV(jsonData: any[], headers?: string[]): string {
    // If headers are not provided, use the keys from the first object in the JSON array
    headers = headers || Object.keys(jsonData[0]);

    let csvData = '';
    csvData += headers.join(',') + '\n';

    for (const item of jsonData) {
      const values = headers.map((h) => {
        let val = item[h] ?? '';
        if (typeof val === 'string') {
          val = val.replace(/"/g, '""');
        }
        return `"${val}"`;
      });
      csvData += values.join(',') + '\n';
    }

    return csvData;
  }
  openMultiplePagingBoard() {
    this.openMultiplePagingBoardPopup = true;
  }
  onGetMultiplePagingBoardChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.openMultiplePagingBoardPopup = false;
        break;
    }
  }
}
